import axios from 'axios'
import router from '@/router';
import store from '@/store/index';

export default () => {

	const instance = axios.create({
		baseURL: process.env.VUE_APP_TEF_API_URI,
		withCredentials: false,
		headers: {
			'Accept': 'application/json',
			'Content-Type': 'application/json'
		}
	})
	// const CancelToken = axios.CancelToken;

	instance.interceptors.response.use((response) => {
		if(response.data && response.data.messageError && response.data.messageError.includes("127.0.0.1:60906")){
			const error = new Error("Falha na comunicação com Client V$Pague. Verifique se o serviço está executando, ou inicie ele novamente.")
			return Promise.reject(error)
		}
		return response
	}, async (error) => {
		const originalRequest = error.config;
		const access_token = localStorage.getItem("token");

		if (Object.prototype.hasOwnProperty.call(error, "message")){
			if(error.message === "Network Error"){
				error = new Error("Falha na comunicação com OryxTefClient. Verifique se o serviço está executando, ou inicie ele novamente.")
				return Promise.reject(error)
			}
			return Promise.reject(error)
		}

		if (!error.response) {
			router.push("/oryx/login")
			return Promise.reject(error)
		}

		if (401 === error.response.status && access_token && !originalRequest._retry) {
			let newToken = await store.dispatch("dc4/revoke")
			if(newToken){
				originalRequest.headers.Authorization = "Bearer " + newToken
				return axios(originalRequest);
			}
		}
		if (401 === error.response.status)
			router.push("/oryx/login")
		return Promise.reject(error)
	})

	instance.interceptors.request.use(async config  => {
		let newToken = localStorage.getItem("token");
		let auth = null
		if(config.headers.common.Authorization){
			auth = config.headers.common.Authorization.split("Bearer ")[1]
		}
		if (newToken && auth && newToken != auth){
			config.headers.common.Authorization = "Bearer " + newToken
		}
	// 	const source = CancelToken.source()
	// 	config.CancelToken = source.token
	// 	if (!(await store.dispatch("dc4/check")) && store.state.dc4.userLogged){
	// 		source.cancel("sessão expirou")
	// 		router.push("/logoff")
	// 	}
		return config
	}, error => {
		return Promise.reject(error)
	})

	return instance
}
